import { render, staticRenderFns } from "./develop-your-typing-skills.vue?vue&type=template&id=6a3cdefe&"
import script from "./develop-your-typing-skills.vue?vue&type=script&lang=js&"
export * from "./develop-your-typing-skills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports